// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import { Eye, EyeOff } from "lucide-react";
// import config from "./Config/config";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const { login } = useAuth();
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setIsLoading(true);
//     try {
//       const response = await fetch(`${config.API_BASE_URL}/login/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, password }),
//       });
//       if (response.ok) {
//         const data = await response.json();
//         login(data.access_token);
//         navigate("/");
//       } else {
//         const errorData = await response.json();
//         setError(errorData.message || "Login failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       setError("An unexpected error occurred. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 px-4 py-12 sm:px-6 lg:px-8">
//       <div className="w-full max-w-md space-y-8 rounded-xl bg-white p-8 shadow-2xl transition-all duration-300 hover:shadow-3xl">
//         <div>
//           <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
//             Login
//           </h2>
//         </div>

//         <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
//           {error && (
//             <div className="rounded-md bg-red-50 p-4">
//               <div className="flex">
//                 <div className="ml-3">
//                   <h3 className="text-sm font-medium text-red-800">{error}</h3>
//                 </div>
//               </div>
//             </div>
//           )}

//           <div className="space-y-4 rounded-md shadow-sm">
//             <div>
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//                 className="relative block w-full rounded-lg border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-500 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//                 placeholder="Email address"
//               />
//             </div>

//             <div className="relative">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//                 className="relative block w-full rounded-lg border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-500 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
//                 placeholder="Password"
//               />
//               <button
//                 type="button"
//                 onClick={togglePasswordVisibility}
//                 className="absolute right-3 top-1/2 -translate-y-1/2 transform text-gray-400 hover:text-gray-600"
//               >
//                 {showPassword ? (
//                   <EyeOff className="h-5 w-5" />
//                 ) : (
//                   <Eye className="h-5 w-5" />
//                 )}
//               </button>
//             </div>
//           </div>

//           <div>
//             <button
//               type="submit"
//               disabled={isLoading}
//               className="group relative flex w-full justify-center rounded-lg bg-indigo-600 px-4 py-3 text-sm font-semibold text-white transition-all hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:bg-gray-400"
//             >
//               {isLoading ? (
//                 <div className="flex items-center">
//                   <svg
//                     className="mr-2 h-4 w-4 animate-spin text-white"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                     ></path>
//                   </svg>
//                   Logging in...
//                 </div>
//               ) : (
//                 "Log In"
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

// ********************************************************************************* code by amal

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import { Eye, EyeOff } from "lucide-react";
// import config from "./Config/config";

// // Color palette - using only the specified colors
// const COLORS = {
//   green: "#221b8dff",
//   green2: "#9aa390ff",
//   white: "#FAFAFA",
// };

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const { login } = useAuth();
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setIsLoading(true);
//     try {
//       const response = await fetch(`${config.API_BASE_URL}/login/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, password }),
//       });
//       if (response.ok) {
//         const data = await response.json();
//         login(data.access_token);
//         navigate("/");
//       } else {
//         const errorData = await response.json();
//         setError(errorData.message || "Login failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       setError("An unexpected error occurred. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <div
//       className="flex min-h-screen items-center justify-center px-4 py-12 sm:px-6 lg:px-8"
//       style={{ backgroundColor: COLORS.white }}
//     >
//       <div
//         className="w-full max-w-md space-y-8 rounded-xl p-8 shadow-2xl transition-all duration-300 hover:shadow-3xl"
//         style={{
//           backgroundColor: COLORS.white,
//           borderColor: COLORS.green2,
//           borderWidth: "1px",
//         }}
//       >
//         <div>
//           <h2
//             className="mt-6 text-center text-3xl font-bold tracking-tight"
//             style={{ color: "black" }}
//           >
//             Login
//           </h2>
//         </div>

//         <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
//           {error && (
//             <div
//               className="rounded-md p-4"
//               style={{ backgroundColor: "#FEE2E2" }}
//             >
//               <div className="flex">
//                 <div className="ml-3">
//                   <h3
//                     className="text-sm font-medium"
//                     style={{ color: "#991B1B" }}
//                   >
//                     {error}
//                   </h3>
//                 </div>
//               </div>
//             </div>
//           )}

//           <div className="space-y-4 rounded-md shadow-sm">
//             <div>
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//                 className="relative block w-full rounded-lg border px-4 py-3 text-gray-900 placeholder-gray-500 sm:text-sm"
//                 style={{
//                   borderColor: COLORS.green2,
//                   backgroundColor: COLORS.white,
//                   color: COLORS.green,
//                 }}
//                 placeholder="Email address"
//               />
//             </div>

//             <div className="relative">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//                 className="relative block w-full rounded-lg border px-4 py-3 text-gray-900 placeholder-gray-500 sm:text-sm"
//                 style={{
//                   borderColor: COLORS.green2,
//                   backgroundColor: COLORS.white,
//                   color: COLORS.green,
//                 }}
//                 placeholder="Password"
//               />
//               <button
//                 type="button"
//                 onClick={togglePasswordVisibility}
//                 className="absolute right-3 top-1/2 -translate-y-1/2 transform hover:text-gray-600"
//                 style={{ color: COLORS.green }}
//               >
//                 {showPassword ? (
//                   <EyeOff className="h-5 w-5" />
//                 ) : (
//                   <Eye className="h-5 w-5" />
//                 )}
//               </button>
//             </div>
//           </div>

//           <div>
//             <button
//               type="submit"
//               disabled={isLoading}
//               className="group relative flex w-full justify-center rounded-lg px-4 py-3 text-sm font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-gray-400"
//               style={{
//                 backgroundColor: COLORS.green,
//                 color: COLORS.white,
//               }}
//               onMouseOver={(e) => {
//                 e.currentTarget.style.backgroundColor = "#4A5439"; // Darker shade of the green
//               }}
//               onMouseOut={(e) => {
//                 e.currentTarget.style.backgroundColor = COLORS.green;
//               }}
//             >
//               {isLoading ? (
//                 <div className="flex items-center">
//                   <svg
//                     className="mr-2 h-4 w-4 animate-spin"
//                     style={{ color: COLORS.white }}
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                     ></path>
//                   </svg>
//                   Logging in...
//                 </div>
//               ) : (
//                 "Log In"
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;



import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { Eye, EyeOff } from "lucide-react";
import config from "./Config/config";

// Color palette
const COLORS = {
  green: "#221b8dff",
  green2: "#9aa390ff",
  white: "#FAFAFA",
};

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      if (response.ok) {
        const data = await response.json();
        login(data.access_token);
        navigate("/");
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Login failed. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center px-4 py-12 sm:px-6 lg:px-8"
      style={{ backgroundColor: COLORS.white }}
    >
      <div
        className="w-full max-w-md space-y-8 rounded-xl p-8 shadow-2xl transition-all duration-300 hover:shadow-3xl"
        style={{
          backgroundColor: COLORS.white,
          borderColor: COLORS.green2,
          borderWidth: "1px",
        }}
      >
        <div>
          <h2
            className="mt-6 text-center text-3xl font-bold tracking-tight"
            style={{ color: "black" }}
          >
            Login
          </h2>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div
              className="rounded-md p-4"
              style={{ backgroundColor: "#FEE2E2" }}
            >
              <div className="flex">
                <div className="ml-3">
                  <h3
                    className="text-sm font-medium"
                    style={{ color: "#991B1B" }}
                  >
                    {error}
                  </h3>
                </div>
              </div>
            </div>
          )}

          <div className="space-y-4 rounded-md shadow-sm">
            <div>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="relative block w-full rounded-lg border px-4 py-3 text-gray-900 placeholder-gray-500 sm:text-sm"
                style={{
                  borderColor: COLORS.green2,
                  backgroundColor: COLORS.white,
                  color: COLORS.green,
                }}
                placeholder="Username"
              />
            </div>

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="relative block w-full rounded-lg border px-4 py-3 text-gray-900 placeholder-gray-500 sm:text-sm"
                style={{
                  borderColor: COLORS.green2,
                  backgroundColor: COLORS.white,
                  color: COLORS.green,
                }}
                placeholder="Password"
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute right-3 top-1/2 -translate-y-1/2 transform hover:text-gray-600"
                style={{ color: COLORS.green }}
              >
                {showPassword ? (
                  <EyeOff className="h-5 w-5" />
                ) : (
                  <Eye className="h-5 w-5" />
                )}
              </button>
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="group relative flex w-full justify-center rounded-lg px-4 py-3 text-sm font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-gray-400"
              style={{
                backgroundColor: COLORS.green,
                color: COLORS.white,
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#1c105fff";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = COLORS.green;
              }}
            >
              {isLoading ? (
                <div className="flex items-center">
                  <svg
                    className="mr-2 h-4 w-4 animate-spin"
                    style={{ color: COLORS.white }}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Logging in...
                </div>
              ) : (
                "Log In"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;